module.exports = __webpack_public_path__ + "post.svg?186da697e8377ed480f759e126d096f8";